import { render, staticRenderFns } from "./nutritiousDiningProcurement.vue?vue&type=template&id=6ca0a9d4&scoped=true&"
import script from "./nutritiousDiningProcurement.vue?vue&type=script&lang=js&"
export * from "./nutritiousDiningProcurement.vue?vue&type=script&lang=js&"
import style0 from "./nutritiousDiningProcurement.vue?vue&type=style&index=0&id=6ca0a9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca0a9d4",
  null
  
)

export default component.exports